import moment from 'moment-timezone';

export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

export const TIMEZONE_OPTIONS = [
  { value: 'America/Los_Angeles', label: 'Pacific Time (Los Angeles)' },
  { value: 'America/Denver', label: 'Mountain Time (Denver)' },
  { value: 'America/Chicago', label: 'Central Time (Chicago)' },
  { value: 'America/New_York', label: 'Eastern Time (New York)' },
  { value: 'America/Phoenix', label: 'Arizona (Phoenix)' },
  { value: 'America/Anchorage', label: 'Alaska (Anchorage)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (Honolulu)' },
  { value: 'America/Toronto', label: 'Eastern Canada (Toronto)' },
  { value: 'America/Vancouver', label: 'Pacific Canada (Vancouver)' },
  { value: 'Europe/London', label: 'UK (London)' },
  { value: 'Europe/Paris', label: 'Central Europe (Paris)' },
  { value: 'Europe/Berlin', label: 'Central Europe (Berlin)' },
  { value: 'Asia/Dubai', label: 'Gulf (Dubai)' },
  { value: 'Asia/Karachi', label: 'Pakistan (Karachi)' },
  { value: 'Asia/Kolkata', label: 'India (Kolkata)' },
  { value: 'Asia/Singapore', label: 'Singapore' },
  { value: 'Asia/Tokyo', label: 'Japan (Tokyo)' },
  { value: 'Australia/Sydney', label: 'Australia (Sydney)' },
  { value: 'UTC', label: 'UTC' },
];

/** Include the saved timezone even when it is not in the preset list (avoids a misleading select value). */
export function buildTimezoneOptions(activeTimezone) {
  const tz = String(activeTimezone || '').trim();
  if (!tz || !moment.tz.zone(tz)) {
    return TIMEZONE_OPTIONS;
  }
  if (TIMEZONE_OPTIONS.some((option) => option.value === tz)) {
    return TIMEZONE_OPTIONS;
  }
  return [...TIMEZONE_OPTIONS, { value: tz, label: tz.replace(/_/g, ' ') }];
}
